module.exports = __webpack_public_path__ + "media/13.9cd5ced4.mp3";